'use strict';

var mcsclient = require('./client');

module.exports = mcsclient;